import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

/**
 * Минимальная shadcn-совместимая кнопка (scaffold). Стили — через CSS-классы
 * `btn btn-{variant}` (см. styles.css), что упрощает последующую замену на полноценный
 * shadcn/ui + Tailwind после прихода макетов (UX-Gate).
 */
export function Button({ variant = 'primary', className, children, ...rest }: ButtonProps) {
  const cls = ['btn', `btn-${variant}`, className].filter(Boolean).join(' ');
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
